import { Order } from 'entities/orders';
import { OrderBookingData } from 'entities/orders/model/types';
import { useCallback } from 'react';
import { Game } from 'shared/lib/core';
import { localStorageItem } from 'shared/lib/core/lib/utils';

export const useOrderResources = (order: Order | null | undefined) => {
	const getResourcesIdsFormOrder = useCallback(() => {
		const savedData = localStorageItem('booking') as OrderBookingData;

		const resources = order?.appointment?.resources;
		if (resources) {
			const resourcesIds = resources.map(resource => resource.id);
			return resourcesIds;
		}

		if (savedData) {
			return savedData.resources;
		}

		return [];
	}, [order]);

	const setResourcesByOrder = useCallback(
		(game: Game) => {
			const resources = getResourcesIdsFormOrder();
			game.resources.forEach(resource => {
				if (resources.includes(resource.id)) {
					resource.select(true);
				}
			});
		},
		[getResourcesIdsFormOrder],
	);

	return {
		setResourcesByOrder,
		getResourcesIdsFormOrder,
	};
};
